import React from 'react';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import DropdownMenu from './DropdownMenu';

interface MenuItem {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  className?: string;
  divider?: boolean;
}

interface ThreeDotsMenuProps {
  items: MenuItem[];
  buttonClassName?: string;
  menuClassName?: string;
}

export default function ThreeDotsMenu({ items, buttonClassName = '', menuClassName = '' }: ThreeDotsMenuProps) {
  return (
    <DropdownMenu 
      items={items}
      buttonClassName={buttonClassName}
      menuClassName={menuClassName}
    />
  );
}